import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="login-logs"
export default class extends Controller {
  static targets = [
    'loggedOutAtStart', 'loggedOutAtEnd', 'loggedOutAt',
    'loggedOutAtNullOr', 'loggedOutAtNullOrStart', 'loggedOutAtNullOrEnd'
  ]

  changeLoggedOutType(event) {
    var q_logged_out_at_gteq = document.getElementById("q_logged_out_at_gteq")
    var q_logged_out_at_null_or_gteq = document.getElementById("q_logged_out_at_null_or_gteq")
    var q_logged_out_at_lteq = document.getElementById("q_logged_out_at_lteq")
    var q_logged_out_at_null_or_lteq = document.getElementById("q_logged_out_at_null_or_lteq")

    if (event.target.value == 'only_not') {
      this.disableSelect([
        this.loggedOutAtStartTarget, this.loggedOutAtEndTarget, this.loggedOutAtNullOrStartTarget, this.loggedOutAtNullOrEndTarget
      ], false)
      return
    } else if (event.target.value == 'include') {
      q_logged_out_at_null_or_gteq.value = q_logged_out_at_gteq.value
      q_logged_out_at_gteq.value = null
      q_logged_out_at_null_or_lteq.value = q_logged_out_at_lteq.value
      q_logged_out_at_lteq.value = null
      this.disableSelect([this.loggedOutAtStartTarget, this.loggedOutAtEndTarget], true)
      this.enableSelect([this.loggedOutAtNullOrStartTarget, this.loggedOutAtNullOrEndTarget])
      this.loggedOutAtNullOrTarget.classList.remove("d-none")
      this.loggedOutAtTarget.classList.add("d-none")
    } else if (event.target.value == 'not_include') {
      q_logged_out_at_gteq.value = q_logged_out_at_null_or_gteq.value
      q_logged_out_at_null_or_gteq.value = null
      q_logged_out_at_lteq.value = q_logged_out_at_null_or_lteq.value
      q_logged_out_at_null_or_lteq.value = null
      this.disableSelect([this.loggedOutAtNullOrStartTarget, this.loggedOutAtNullOrEndTarget], true)
      this.enableSelect([this.loggedOutAtStartTarget, this.loggedOutAtEndTarget])
      this.loggedOutAtTarget.classList.remove("d-none")
      this.loggedOutAtNullOrTarget.classList.add("d-none")
    }
  }

  disableSelect(targets, holdValue = false) {
    targets.forEach(target => {
      if (!holdValue) {
        target.value = null
      }
      target.disabled = true
    })
  }

  enableSelect(targets) {
    targets.forEach(target => {
      target.disabled = false
    })
  }
}
